﻿export const es = {
  apply: "Aplicar",
  cart_is_empty: "Su carrito está vacío. Descubra productos para agregar a su carrito",
  browse_products: "Explorar productos",
  invalid_coupon: "Ingresó un código de descuento no válido. Compruebe el código e inténtelo de nuevo.",
  duplicate_coupon: "Ya se aplicó el código de descuento {{couponInputValue}}",
  products: "Productos",
  product: "Producto",
  qty: "CANT.",
  price: "Precio",
  remove: "Eliminar",
  add_to_cart: "Agregar al carrito",
  show_more: "Mostrar más",
  show_less: "Mostrar menos",
  order_summary: "Resumen del pedido",
  your_cart: "Su carrito",
  item: "artículo",
  items: "artículos",
  enter_discount_code: "Ingresar código de descuento",
  continue_shopping: "Continuar comprando",
  i_agree: "Al continuar, acepto que he leído y acepto lo siguiente:",
  privacy_policy: "Política de privacidad",
  refund_policy: "Política de reembolso",
  terms_of_use: "Términos de uso",
  and: "y",
  total: "Total",
  exclude: "Excluye",
  include: "Incluye",
  tax: "Impuesto",
  subtotal: "Subtotal",
  discount: "Descuento",
  coupon_discount: "Descuento con cupón",
  checkout: "Área de pago"
};